import React from 'react'
import { Button, Card } from 'react-bootstrap'

const RemoteOnboardingExecutiveTraining = () => {
  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'>Remote Onboarding and Executive Training</Card.Title>
                <Card.Text className='industrial-environment-text'>
                Our world has gone remote. New employee onboarding may happen at any time, in any part of the world. VR and AR can help employees get a feel for the company and its leaders through holograms, virtual facility walkthroughs, and virtual workspaces.
                </Card.Text>

                <Card.Subtitle className="industrial-modeling-subtitle pt-4">Leadership Development and Executive Training Case Study</Card.Subtitle>
                <Card.Text className='industrial-environment-text'>
				For one client, we helped create an AR/VR “Leader Library” of over two hours of wisdom from 18 of the company’s senior leaders.
                </Card.Text>
                
            </Card.Body>
        </Card>
            <div className="onboard-slideshow d-none d-md-block">
				<div className="image-mover"></div>
			</div>


            <div className="mobile-onboard-slideshow d-sm-block d-md-none">
				<div className="mobile-image-mover"></div>
			</div>

			<Card className='no-border rounded-0 container py-md-4'>
			<Card.Title className='leadership-executive-bottom-title'>Make training and onboarding fun, interactive, and immersive.</Card.Title>
			<Button className='yellow-schedule-button shelterinplacevr-button btn btn-warning'><a href="https://www.paracosma.com/#contact-form" target="_blank" rel="noreferrer">Schedule a Consultation </a></Button>
			</Card>
      
    </>
  )
}

export default RemoteOnboardingExecutiveTraining
